/**
 * @Author: ZLZ
 * @Date: 2025-10-22 19:00:00
 * @LastEditors: ZLZ
 * @LastEditTime: 2025-10-22 19:00:00
 * @Description: 2.0 内容 龙湖掘金 路由模块
 * @FilePath: \qs\src\router\modules\longHuJueJin.js
 */
import Layout from "@/Layout";
export default [
  {
    path: "/longHuJueJin",
    component: Layout,
    name: "LongHuJueJin",
    redirect: "/longHuJueJin/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/longHuJueJin/index.vue"),
        meta: {
          title: "龙虎掘金",
          keepAlive: false,
          showFooter: false,
          showHead: true,
          showLeft: true,
          showRight: false
        }
      },
      {
        path: 'detailLHJJ',
        component: () => import("@/views/longHuJueJin/detailLHJJ.vue"),
        meta: {
          title: '', // 龙虎掘金详情
          keepAlive: false,
          showFooter: false,
          showHead: false,
          showLeft: false,
          showRight: false
        }
      }
    ]
  },
];
